import { render } from "./Footer.vue?vue&type=template&id=32bb5360&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=32bb5360&scoped=true&lang=css"

import exportComponent from "D:\\My Project\\NewBlog\\WEB\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32bb5360"]])

export default __exports__